// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__26tx2","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__XaOKo"};